// extracted by mini-css-extract-plugin
export default {"activeBlock":"active-block-module__activeBlock--LsnRY","delimiter":"active-block-module__delimiter--P753z"};